export default __webpack_public_path__ + "static/media/CookingImage6.042d82e2.png";